module.exports = " <div ui-calendar=importScope.uiConfig.calendar ng-model=importScope.calendarEventSources> </div>";


//////////////////
// WEBPACK FOOTER
// .-dna/app/sections/6-books/inspect.calendar.overview.html
// module id = 195
// module chunks = 86